"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProfessionalMilestones() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const milestones = [{
    year: "2010",
    label: "COMIENZOS",
    description: "Comenzó en los Estados Unidos, graduándose de Toulouse Lautrec con un título en diseño de interiores.",
    image: "https://nikibmakeup.com/wp-content/uploads/2026/06/images.jpeg?v=jib21h3fqx",
    srcset: "https://nikibmakeup.com/wp-content/uploads/2026/06/images.jpeg?v=icrxkfz5v9",
    sizes: "https://nikibmakeup.com/wp-content/uploads/2026/06/images.jpeg?v=gtvu4zfzg7a",
    alt: "Niki B. Makeup studio founding",
    position: "top"
  }, {
    year: "2017",
    label: "DEBUT EDITORIAL",
    description: "Trabajando en Perú, comenzó en un spa realizando faciales y depilación láser mientras completaba la formación necesaria para el maquillaje profesional.",
    image: "https://nikibmakeup.com/wp-content/uploads/2026/06/download.jpeg?v=og4fqywobv",
    srcset: "https://nikibmakeup.com/wp-content/uploads/2026/06/download.jpeg?v=94ei2ji4qw8",
    sizes: "https://nikibmakeup.com/wp-content/uploads/2026/06/download.jpeg?v=p0sc2vvmpp",
    alt: "First editorial makeup shoot",
    position: "bottom"
  }, {
    year: "2019",
    label: "CURSOS DE MAQUILLAJE",
    description: "Impartió cursos de maquillaje en The Style Institute, haciendo la transición a clases por Zoom.",
    image: "https://nikibmakeup.com/wp-content/uploads/2026/06/K9YTlHD6SaOJsOQwlfWU_Kajabi_Image-e1781254398138.jpeg?v=7ys6kt1y362",
    srcset: "https://nikibmakeup.com/wp-content/uploads/2026/06/K9YTlHD6SaOJsOQwlfWU_Kajabi_Image-e1781254398138.jpeg?v=zq22iexc4rb",
    sizes: "https://nikibmakeup.com/wp-content/uploads/2026/06/K9YTlHD6SaOJsOQwlfWU_Kajabi_Image-e1781254398138.jpeg?v=uebb6fhm63d",
    alt: "Madrid studio expansion",
    position: "top"
  }, {
    year: "2021",
    label: "MADRID",
    description: "Se mudó de Perú a Madrid, completó una maestría en maquillaje y peluquería para bellas artes en Kohl School y trabajó en moda para la Madrid Fashion Week.",
    image: "https://nikibmakeup.com/wp-content/uploads/2026/06/klh_school_logo.jpeg?v=m3pc1j1psl",
    srcset: "https://nikibmakeup.com/wp-content/uploads/2026/06/klh_school_logo.jpeg?v=dg7fv8jpksv",
    sizes: "https://nikibmakeup.com/wp-content/uploads/2026/06/klh_school_logo.jpeg?v=tk594oglwh",
    alt: "Professional makeup masterclass",
    position: "bottom"
  }, {
    year: "2024",
    label: "VALENCIA",
    description: "Se mudó a Valencia y se unió a Pilar Models realizando maquillaje y peluquería para modelaje.",
    image: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-12-105738.png?v=jcd3yevtul",
    srcset: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-12-105738.png?v=02wsr6a9061i",
    sizes: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-12-105738.png?v=4zk92xsv56v",
    alt: "Signature bridal makeup look",
    position: "top"
  }, {
    year: "2025",
    label: "TRABAJO DE CAMPAÑA",
    description: "Comenzó a trabajar de forma independiente para novias, eventos sociales y lecciones privadas de maquillaje, con experiencia en diferentes tipos de piel y otras cualidades.",
    image: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-12-110344.png?v=2e37jfs9r71",
    srcset: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-12-110344.png?v=5ostfg54gex",
    sizes: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-12-110344.png?v=2imuvzpip4j",
    alt: "Commercial beauty campaign work",
    position: "bottom"
  }, {
    year: "2026",
    label: "CONTINUANDO",
    description: "Celebrando 10 años de arduo trabajo y dedicación, mientras expande su negocio.",
    image: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-12-110653.png?v=kjt59dy27qr",
    srcset: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-12-110653.png?v=p9gs34ess1o",
    sizes: "https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-12-110653.png?v=p4lv0aojgj",
    alt: "Ten years of Niki B. Makeup",
    position: "top"
  }];
  return <section data-section-id="2567" id="professional-milestones" ref={sectionRef} className="dark bg-background text-foreground relative overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" aria-hidden="true" style={{
      backgroundImage: "repeating-linear-gradient(to right, var(--muted-foreground) 0, var(--muted-foreground) 1px, transparent 1px, transparent 80px)"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--primary)] mb-6">
            02 &mdash; Hitos
          </p>
          <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-foreground">Más de una década, <em data-ast-id="f:/src/pages/About/sections/ProfessionalMilestones.tsx|sig:qzodrw" data-ast-start="5297" data-ast-end="5313">refinada</em>.</h2>
          <div className="mt-8 h-px w-16 bg-[var(--primary)]/60" />
        </div>

        <div className="hidden lg:block">
          <div className="relative">
            <div className="absolute left-0 right-0 top-[48%] h-px bg-[var(--primary)]/20 -translate-y-1/2">
              <div className="h-full bg-[var(--primary)] origin-left transition-transform ease-out" style={{
              transform: isVisible ? "scaleX(1)" : "scaleX(0)",
              transitionDuration: "1800ms"
            }} />
            </div>

            <div className="relative">
              <div className="relative grid grid-cols-7 gap-4">
                {milestones.map((milestone, i) => <div key={i} data-index={i} className="relative flex flex-col items-center" style={{
                minHeight: "640px",
                marginBottom: "1.5rem"
              }}>
                    <div className={`absolute left-0 right-0 px-1 transition-all ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
                  transitionDuration: "700ms",
                  transitionDelay: `${400 + i * 180}ms`,
                  top: milestone.position === "top" ? "0" : "auto",
                  bottom: milestone.position === "bottom" ? "0" : "auto"
                }}>
                      {milestone.position === "top" ? <div className="flex flex-col items-center text-center">
                          <div className="w-20 aspect-[3/4] overflow-hidden mb-4 bg-muted">
                            <img src={milestone.image} data-wvc-srcset={milestone.srcset} data-wvc-sizes={milestone.sizes} alt={milestone.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                          </div>
                          <div className="font-serif font-default text-[4rem] leading-none font-light text-foreground tracking-tight">
                            {milestone.year}
                          </div>
                          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--primary)] mt-3 mb-2">
                            {milestone.label}
                          </p>
                          <p className="text-[13px] leading-snug text-muted-foreground max-w-[180px]">
                            {milestone.description}
                          </p>
                        </div> : null}
                    </div>

                    <div className="absolute left-1/2 top-[48%] -translate-x-1/2 -translate-y-1/2 z-10">
                      <div className={`h-3 w-px bg-[var(--primary)] transition-opacity ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
                    transitionDuration: "400ms",
                    transitionDelay: `${600 + i * 180}ms`
                  }} />
                      
                    </div>

                    <div className={`absolute left-0 right-0 px-1 transition-all ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
                  transitionDuration: "700ms",
                  transitionDelay: `${400 + i * 180}ms`,
                  display: milestone.position === "bottom" ? "block" : "none",
                  top: "52%"
                }}>
                      <div className="flex flex-col items-center text-center">
                        <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--primary)] mb-2 order-3 mt-3">
                          {milestone.label}
                        </p>
                        <div className="font-serif font-default text-[4rem] leading-none font-light text-foreground tracking-tight order-2">
                          {milestone.year}
                        </div>
                        <div className="w-20 aspect-[3/4] overflow-hidden mb-4 bg-muted order-1">
                          <img src={milestone.image} data-wvc-srcset={milestone.srcset} data-wvc-sizes={milestone.sizes} alt={milestone.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                        </div>
                        <p className="text-[13px] leading-snug text-muted-foreground max-w-[180px] order-4">
                          {milestone.description}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        <div className="hidden md:block lg:hidden">
          <div className="relative overflow-x-auto pb-6">
            <div className="relative" style={{
            minWidth: "1400px"
          }}>
              <div className="absolute left-0 right-0 top-1/2 h-px bg-[var(--primary)]/20 -translate-y-1/2">
                <div className="h-full bg-[var(--primary)] origin-left transition-transform ease-out" style={{
                transform: isVisible ? "scaleX(1)" : "scaleX(0)",
                transitionDuration: "1800ms"
              }} />
              </div>
              <div className="relative grid grid-cols-7 gap-6">
                {milestones.map((milestone, i) => <div key={i} data-index={i} className="relative flex flex-col items-center" style={{
                minHeight: "560px"
              }}>
                    <div className={`absolute left-0 right-0 px-2 text-center transition-all ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"} ${milestone.position === "top" ? "top-0" : "bottom-0"}`} style={{
                  transitionDuration: "700ms",
                  transitionDelay: `${400 + i * 150}ms`
                }}>
                      <div className="flex flex-col items-center">
                        <div className="w-16 aspect-[3/4] overflow-hidden mb-3 bg-muted">
                          <img src={milestone.image} data-wvc-srcset={milestone.srcset} data-wvc-sizes={milestone.sizes} alt={milestone.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                        </div>
                        <div className="font-serif font-default text-5xl leading-none font-light text-foreground tracking-tight">
                          {milestone.year}
                        </div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--primary)] mt-2 mb-2">
                          {milestone.label}
                        </p>
                        <p className="text-xs leading-snug text-muted-foreground">
                          {milestone.description}
                        </p>
                      </div>
                    </div>
                    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 size-1.5 bg-[var(--primary)]" />
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        <div className="md:hidden">
          <div className="relative pl-8">
            <div className="absolute left-2 top-0 bottom-0 w-px bg-[var(--primary)]/20">
              <div className="w-full bg-[var(--primary)] origin-top transition-transform ease-out" style={{
              transform: isVisible ? "scaleY(1)" : "scaleY(0)",
              transitionDuration: "1800ms",
              height: "100%"
            }} />
            </div>

            <div className="space-y-14">
              {milestones.map((milestone, i) => <div key={i} data-index={i} className={`relative transition-all ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
              transitionDuration: "700ms",
              transitionDelay: `${300 + i * 120}ms`
            }}>
                  <div className="absolute -left-[26px] top-3 flex items-center">
                    <div className="size-1.5 bg-[var(--primary)]" />
                    <div className="h-px w-3 bg-[var(--primary)]" />
                  </div>

                  <div className="flex gap-4 items-start">
                    <div className="w-16 aspect-[3/4] overflow-hidden bg-muted shrink-0">
                      <img src={milestone.image} data-wvc-srcset={milestone.srcset} data-wvc-sizes={milestone.sizes} alt={milestone.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-serif font-default text-5xl leading-none font-light text-foreground tracking-tight">
                        {milestone.year}
                      </div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--primary)] mt-3 mb-2">
                        {milestone.label}
                      </p>
                      <p className="text-sm leading-snug text-muted-foreground">
                        {milestone.description}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}